(function (upp) {
    'use strict';

    var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE + "points";
    var URL_WEB_SOCKET_ASSIGN_SERVER = $UPP.URL_WEB_SOCKET_CHILDUPP + "check/user/points";
    var URL_WEB_SOCKET_REDEEM_SERVER = $UPP.URL_WEB_SOCKET_CHILDUPP + "check/redeem/prize";

    upp.service('pointsService', ['appi', '$q', '$window', '$rootScope', '$timeout',

        function (appi, $q, $window, $rootScope, $timeout) {
            /**
             * Return the PointCard with their PrizePoints
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             * @private
             */
            var _getPointsCard = (function ($q, angular) {

                var pointscard,
                    _copy = angular.copy;

                return function () {
                    var deferred = $q.defer();
                    appi.http.get(URL_API_REST_SERVER + '/list')
                        .then(function (response) {
                            pointscard = _copy(response.data) || null;
                            deferred.resolve(pointscard);
                        }, function (err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                };
            })($q, angular);

            /**
             * Returns the qr image in base64 for the points card for the given user
             * Securable
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             * @private
             */
            var _getUserPoints = (function ($q) {
                return function () {

                    var deferred = $q.defer();
                    appi.http.getSecure(URL_API_REST_SERVER + '/user/points')
                        .then(function (response) {
                            deferred.resolve(response.data);
                        }, function (err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                };
            })($q);

            /**
             * Return the PrizePoints with their qrCode, points and id
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             * @private
             */
            var _getPrizePointCard = (function ($q, angular) {

                var prizePointCard,
                    _copy = angular.copy;

                return function (id) {
                    var deferred = $q.defer();
                    appi.http.getSecure(URL_API_REST_SERVER + '/prize/' + id)
                        .then(function (response) {
                            prizePointCard = _copy(response.data) || null;
                            deferred.resolve(prizePointCard);
                        }, function (err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;

                };
            })($q, angular);

            /**
             * Get the users prizes points card
             *
             * @return {Promise} with an array of prizes
             */
            var _getUserPrizes = (function () {
                return function () {
                    return appi.http.getSecure(URL_API_REST_SERVER + '/user/prizes')
                        .then(function (response) {
                            return response.data;
                        });
                };
            })();



            /**
             * Check if a new points are added to the user.
             *
             * @param {number} actual points
             * @returns {Promise} resolved when new points are added to the user
             * @private
             */
            var _checkAssignPointsPoller = (function($q, $timeout) {

                return function(points) {

                    var deferred = $q.defer();
                    var cancel = false;

                    var data = {
                        current: 0,
                        calls: 0,
                        maxCalls: 500 // 500 * 2 sec => ~ 15 min
                    };

                    var poller = function() {
                        if (!cancel) {
                            appi.http.getSecure(URL_API_REST_SERVER + '/user/points/current').then(function(r) {
                                data.current = r.data.current;
                                data.calls++;
                                if (data.current <= points && data.maxCalls > data.calls) {
                                    $timeout(poller, 2000);
                                } else {
                                    deferred.resolve(data.current);
                                }
                            });
                        }
                    };
                    poller();

                    return {
                        onAssignPoints: deferred.promise.then,
                        cancel: function() {
                            cancel = true;
                        }
                    };
                }

            })($q, $timeout);


            /**
             * Check if a new prize are added to the user.
             *
             * @returns {Promise} resolved when the prize are added to the user
             * @private
             */
            var _checkRedeemPrizePoller = (function($q, $timeout) {

                return function() {

                    var deferred = $q.defer();
                    var cancel = false;

                    var data = {
                        calls: 0,
                        maxCalls: 500 // 500 * 2 sec => ~ 15 min
                    };

                    _getUserPrizes().then(function(currentPrizes) {
                        var poller = function() {
                            if (!cancel) {
                                appi.http.getSecure(URL_API_REST_SERVER + '/user/prizes').then(function(r) {
                                    data.current = r.data.current;
                                    data.calls++;
                                    if (r.data.length === currentPrizes.length && data.maxCalls > data.calls) {
                                        $timeout(poller, 2000);
                                    } else {
                                        deferred.resolve(data.current);
                                    }
                                });
                            }

                        };
                        poller();
                    });

                    return {
                        onRedeemPrize: deferred.promise.then,
                        cancel: function() {
                            cancel = true;
                        }
                    };
                }

            })($q, $timeout);


            /**
             * Check if points are assigned to a user is fired
             *
             * @returns {Object} with a method: 'onAssignPoints(fnSuccess, fnError)' that will be fulfilled or rejected
             * @private
             */
            var _checkRedeemPrize = (function($window, $rootScope) {

                var singleton = {
                    ws: null,
                    userId: null,
                };

                return function(userId) {
                    // init websocket...
                    if (!$window.WebSocket) {
                        console.log("websocket not supported");
                    }

                    if (singleton.userId !== userId) {
                        if (singleton.ws != null)
                            singleton.ws.close();

                        var ws = new $window.WebSocket(
                            URL_WEB_SOCKET_ASSIGN_SERVER + "?userId=" + userId
                        );

                        ws.onopen = function (event) {
                            console.log("websocket is on");
                            console.log(event);
                        };

                        ws.onclose = function(event) {
                            console.log("websocket is off");
                            console.log(event);
                        };
                        singleton.ws = ws;
                        singleton.userId = userId;
                    }
                    return {
                        /**
                         *
                         * @param onFnSuccess function fired if stamp check
                         * @param onFnError function fired if some errors happens
                         */
                        onAssignPoints: function(onFnSuccess, onFnError) {
                            console.log("init websocket!")
                            if (singleton.ws == null) {
                                if (onFnError) {
                                    onFnError();
                                    $rootScope.$apply();
                                }
                            }

                            // listen
                            singleton.ws.onmessage = function (message) {
                                console.log('assign points received');
                                console.log(message);
                                onFnSuccess(JSON.parse(message.data));
                                $rootScope.$apply();
                            };

                            singleton.ws.onerror = function (event) {
                                console.log('error websocket');
                                console.log(event);
                                if (onFnError) {
                                    onFnError(event);
                                    $rootScope.$apply();
                                }
                            };
                        }
                    };
                }
            })($window, $rootScope);


            /**
             * Check if a redeem prize is fired
             *
             * @returns {Object} with a method: 'onRedeemPrize(fnSuccess, fnError)' that will be fulfilled or rejected
             * @private
             */
            var _getRedeemConnection = (function($window, $rootScope) {

                var singleton = {
                    ws: null,
                    userId: null,
                    prizeId: null,
                };

                return function(userId, prizeId) {
                    // init websocket...
                    if (!$window.WebSocket) {
                        console.log("websocket not supported");
                    }

                    if (singleton.userId !== userId || singleton.prizeId !== prizeId) {
                        if (singleton.ws != null)
                            singleton.ws.close();

                        var ws = new $window.WebSocket(
                            URL_WEB_SOCKET_REDEEM_SERVER + "?userId=" + userId + "&prizeId=" + prizeId
                        );

                        ws.onopen = function (event) {
                            console.log("websocket is on");
                            console.log(event);
                        };

                        ws.onclose = function(event) {
                            console.log("websocket is off");
                            console.log(event);
                        };
                        singleton.ws = ws;
                        singleton.userId = userId;
                        singleton.prizeId = prizeId;
                    }
                    return {
                        /**
                         *
                         * @param onFnSuccess function fired if stamp check
                         * @param onFnError function fired if some errors happens
                         */
                        onRedeemPrize: function(onFnSuccess, onFnError) {
                            console.log("init websocket!")
                            if (singleton.ws == null) {
                                if (onFnError) {
                                    onFnError();
                                    $rootScope.$apply();
                                }
                            }

                            // listen
                            singleton.ws.onmessage = function (message) {
                                onFnSuccess(message);
                                $rootScope.$apply();
                            };

                            singleton.ws.onerror = function (event) {
                                console.log('error websocket');
                                console.log(event);
                                if (onFnError) {
                                    onFnError(event);
                                    $rootScope.$apply();
                                }
                            };
                        }
                    };
                }
            })($window, $rootScope);


            return {
                getUserPoints: _getUserPoints,
                getPrizePointCard: _getPrizePointCard,
                getUserPrizes: _getUserPrizes,
                getPointsCard: _getPointsCard,
                checkRedeemPoints: _checkRedeemPrizePoller,
                checkAssignPoints: _checkAssignPointsPoller
            };
        }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/points/services/points-services.js